import * as React from "react";

import { ListeComponent} from "../Component/ListeComponent"
import { kolonne } from "../Component/components"
import { navigateToRoute } from "../Component/navigation"
import { ILoaderProps } from "../domene"

import Models = Gf.Web.Models;

export class FakturaTabell extends ListeComponent<Models.FakturaFeltType, Models.FakturaListeModell> {
    constructor(props: ILoaderProps) {
        super(props, "Faktura", "Fakturaer", r => navigateToRoute(`/Faktura/${r.EntitetId}`));
    }

    getKolonner(model: Models.FakturaListeModell) {
        return [
            kolonne(model, Models.FakturaFeltType.FakturaNr, "20%"),
            kolonne(model, Models.FakturaFeltType.SumNetto, "20%"),
            kolonne(model, Models.FakturaFeltType.AntallPoliser, "20%"),
            kolonne(model, Models.FakturaFeltType.MottakerNavn, "20%"),
            kolonne(model, Models.FakturaFeltType.UtstedtDato, "20%")
        ];
    }
}


// WEBPACK FOOTER //
// ./Scripts/React/Faktura/FakturaTabell.tsx